const client_id = "cf9e49e6-c48a-4262-9463-5dd4dc50d5b1"

let GRANT_TOKEN: string | undefined = undefined
let TOKEN_EXPIRES_IN: number | undefined = undefined

const isRunningInCRM = () => {
	try {
		return typeof (window.top as any)?.Xrm !== "undefined"
	} catch {
		return false
	}
}

export async function getToken() {
	if (isRunningInCRM()) {
		return "crm_web_resource_context"
	}

	if (GRANT_TOKEN && TOKEN_EXPIRES_IN) {
		const token = GRANT_TOKEN
		const now = Date.now() / 1000
		if (now < TOKEN_EXPIRES_IN) {
			return token
		}
	}
	const params = [
		["client_id", client_id],
		["redirect_uri", "/"],
		["state", "crm_web_service"],
		["nonce", "crm_web_service"]
	]
		.filter(([key, value]) => value && typeof value != "undefined")
		.map(([key, value]) => `${key}=${value}`)
		.join("&")
	const requrl = `/_services/auth/token${params.length > 0 ? "?" : ""}${params}`
	const tr = await fetch(requrl, { method: "post" })
	const token = await tr.text()
	const rstate = tr.headers.get("state")
	const rexpires_in = tr.headers.get("expires_in")
	if (rstate === "crm_web_service" && rexpires_in) {
		await new Promise(resolve => setTimeout(resolve, 1000))
		GRANT_TOKEN = token
		TOKEN_EXPIRES_IN = Date.now() / 1000 + 14 * 60 // 14 minutes into the future
		return token
	}
	return undefined
}
